import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteFolder, getFeedInfo, getFolderInFolder, getFolderRoot, postFolder, postFolderMoveIn, putFolder } from "../../helpers/backend_helper";
import { duplicateFeed, feedMoveToFolder, getFeeds, removeFeed, updateFeed, updateFeedName } from "../feeds/thunk";
import { campaignMoveToFolder, duplicateCampaign, getCampaigns, removeCampaign, updateCampaign } from "../campaigns/thunk";
import { resetSelectedItems, setSelectedItem } from "./reducer";
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setFeedsShowLoader, setSelectedFeedId } from "../feeds/reducer";
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage, setAllLibrariesShowLoader, setCurrentCampaign } from "../campaigns/reducer";
import { toast } from "react-toastify";
import { replace } from "redux-first-history";
import { checkMaintenance } from "../auth/login/helper";

export const newFolder = (data) => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, marketPath, folderPath } = getState().MenuData;
    const {user} = getState().Login;
    const obj = {
      ...data,
      companyId: client._id,
      clientId: clientPath,
      brandId: brandPath,
      marketId: marketPath,
      subOf: folderPath
    }
    const response = await postFolder(obj);
    if (response.status === 'ok') {
      return {
        _id: response.data.insertedId,
        companyId: client._id,
        clientId: clientPath,
        isFolder: true,
        createdBy: user.userId,
        createdDate: new Date().getTime(),
        modifiedDate: new Date().getTime(),
        ...obj
      };
    } else {
      return null;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return null;
  }
};

export const updateFolder = (item) => async (dispatch, getState) => {
  try {
    const title = getState().MenuData.title;
    const {
      feeds,
      feedsHasMore,
      feedsPage
    } = getState().Feed;
    const { 
      allLibraries, 
      allLibrariesHasMore,
      allLibrariesPage
    } = getState().Campaign;
    const response = await putFolder({ id: item._id, name: item.name });
    if (window.location.href.includes('campaigns')) {
      const updatedCampaigns = allLibraries.map(campaign => {
        if (campaign._id === item._id) {
          return {
            ...campaign,
            name: item.name
          }
        } else {
          return campaign;
        }
      })
      dispatch(getAllLibrariesSuccess(updatedCampaigns));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(replace(window.location.href, { 
        title: title,
        campaigns: updatedCampaigns, 
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage
      }));
    } else if (window.location.href.includes('feeds')) {
      const updatedFeeds = feeds.map(feed => {
        if (feed._id === item._id) {
          return {
            ...feed,
            name: item.name
          };
        } else {
          return feed;
        }
      })
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(setFeedsFirstLoad(false));
      dispatch(replace(window.location.href, { 
        title: title,
        feeds: updatedFeeds,
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage 
      }));
    }
    return response;
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
};

export const resetTableFilter = () => async (dispatch, getState) => {
  try {
    // Feed Table Reset
    dispatch(getFeedSuccess(null));
    dispatch(setFeedsLoading(false));
    dispatch(setFeedsHasMore(true));
    dispatch(setFeedsFirstLoad(true));
    dispatch(setFeedsPage(1));
    // Campaign Table Reset
    dispatch(getAllLibrariesSuccess(null));
    dispatch(setAllLibrariesLoading(false));
    dispatch(setAllLibrariesHasMore(true));
    dispatch(setAllLibrariesFirstLoad(true));
    dispatch(setAllLibrariesPage(1));
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

// Feed
export const getFolderRootThunk = createAsyncThunk("folder/getFolderRootData", async (data, { dispatch, getState }) => {
  try {
    const brandId = getState().MenuData.brandPath;
    const folderRootPath = getState().Folder.folderRootPath;
    let response = await getFolderRoot({ brandId: brandId, type: folderRootPath });
    return response.data;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const getFolderInFolderThunk = createAsyncThunk("folder/getFolderInFolderData", async (id, { dispatch, getState }) => {
  try {
    let response = await getFolderInFolder({ id: id });
    return response.data;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const setFolderHistory = createAsyncThunk("folder/setFolderHistoryData", async (data, { dispatch, getState }) => {
  return data;
});

export const removeFolder = (id) => async (dispatch, getState) => {
  try {
    const title = getState().MenuData.title;
    const campaigns = getState().Campaign.allLibraries;
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesFirstLoad,
      allLibrariesPage
    } = getState().Campaign;
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    let response = await deleteFolder({ id: id });
    if (response.status === 'ok') {
      if (window.location.href.includes('campaigns')) {
        const filteredCampaigns = campaigns.filter(item => item._id !== id);
        dispatch(getAllLibrariesSuccess(filteredCampaigns));
        dispatch(setAllLibrariesFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          campaigns: filteredCampaigns,
          hasMore: allLibrariesHasMore,
          firstLoad: false,
          campaignPage: allLibrariesPage
        }));
      } else if (window.location.href.includes('feeds')) {
        const filteredFeeds = feeds.filter(item => item._id !== id);
        dispatch(getFeedSuccess(filteredFeeds));
        dispatch(setFeedsFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          feeds: filteredFeeds,
          hasMore: feedsHasMore,
          firstLoad: false,
          feedsPage: feedsPage,
        }))
      }
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
}

export const folderMoveToFolder = (id, mainFolderId) => async (dispatch, getState) => {
  const {language, title} = getState().MenuData;
  try {
    const campaigns = getState().Campaign.allLibraries;
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesFirstLoad,
      allLibrariesPage
    } = getState().Campaign;
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    let response = await postFolderMoveIn({ id: id, mainFolderId: mainFolderId });
    if (response.status === 'ok') {
      if (window.location.href.includes('campaigns')) {
        const filteredCampaigns = campaigns.filter(item => item._id !== id);
        dispatch(getAllLibrariesSuccess(filteredCampaigns));
        dispatch(setAllLibrariesFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          campaigns: filteredCampaigns,
          hasMore: allLibrariesHasMore,
          firstLoad: false,
          campaignPage: allLibrariesPage
        }));
      } else if (window.location.href.includes('feeds')) {
        const filteredFeeds = feeds.filter(item => item._id !== id);
        dispatch(getFeedSuccess(filteredFeeds));
        dispatch(setFeedsFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          feeds: filteredFeeds,
          hasMore: feedsHasMore,
          firstLoad: false,
          feedsPage: feedsPage,
        }))
      }
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], {autoClose: 3000});
  }
};

export const duplicateItem = (item) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    let response;
    if (item.hasOwnProperty("isFolder")) { // Folder
      return;
    } else if (item.hasOwnProperty("type")) { // Feed
      response = await dispatch(duplicateFeed(item._id));
    } else if (item.hasOwnProperty("adType")) { // Campaign
      response = await dispatch(duplicateCampaign(item));
    }
    if (response.status === 'ok') {
      dispatch(setSelectedItem(null));
      toast.success(language[response?.code], { autoClose: 3000 });
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};

export const duplicateManyCampaign = (duplicateObj) => async (dispatch, getState) => {
  try {
    const { language } = getState().MenuData;
    if (duplicateObj.campaigns.length > 0) {
      let i = 0;
      do {
        const item = duplicateObj.campaigns[i];
        let response = await dispatch(duplicateCampaign({
          ...item,
          name: `${item.name} - Copy`,
          marketId: duplicateObj.marketId,
          marketIcon: duplicateObj.marketIcon
        }));
        if (response.status === 'err') {
          toast.error(language[response?.code], { autoClose: 3000 });
        }
        i++;
      } while (i < duplicateObj.campaigns.length);
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const deleteItem = (item) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    let response;
    if (item.hasOwnProperty("isFolder")) { // Folder
      response = await dispatch(removeFolder(item._id));
    } else if (item.hasOwnProperty("type")) { // Feed
      response = await dispatch(removeFeed(item._id));
    } else if (item.hasOwnProperty("adType")) { // Campaign
      response = await dispatch(removeCampaign(item._id));
    }
    if (response.status === 'ok') {
      dispatch(setSelectedItem(null));
    } else {
      throw response
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const updateItem = (item) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    let response;
    if (item.hasOwnProperty('isFolder')) {
      response = await dispatch(updateFolder(item));
    } else if (item.hasOwnProperty('type')) {
      let feedInfoRes = await getFeedInfo(item._id);
      feedInfoRes.data.name = item.name;
      response = await dispatch(updateFeedName(feedInfoRes.data));
    } else if (item.hasOwnProperty('adType')) {
      response = await dispatch(updateCampaign(item));
    }
    if (response.status === 'ok') {
      dispatch(setSelectedItem(null));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const moveItemToFolder = createAsyncThunk("folder/moveItemToFolder", async ({ item, folder }, { dispatch, getState }) => {
  try {
    let response;
    if (item.hasOwnProperty("isFolder")) { // Folder
      response = await dispatch(folderMoveToFolder(item._id, folder._id));
    } else if (item.hasOwnProperty("type")) { // Feed
      response = await dispatch(feedMoveToFolder(item._id, folder._id));
    } else if (item.hasOwnProperty("adType")) { // Campaign
      response = await dispatch(campaignMoveToFolder(item._id, folder._id));
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const duplicateAllItems = createAsyncThunk("folder/duplicateAllItemsData", async (data, { dispatch, getState }) => {
  try {
    let response;
    const { selectedItems } = getState().Folder;
    let i = 0;
    do {
      response = await dispatch(duplicateItem(selectedItems[i]));
      i++;
    } while (i < selectedItems.length);
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const deleteAllItems = createAsyncThunk("folder/deleteAllItemsData", async (data, { dispatch, getState }) => {
  try {
    let response;
    const { selectedItems } = getState().Folder;
    let i = 0;
    do {
      response = await dispatch(deleteItem(selectedItems[i]));
      i++;
    } while (i < selectedItems.length);
    dispatch(resetSelectedItems());
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const moveAllItemsToFolder = createAsyncThunk("folder/moveAllItemsToFolder", async (data, { dispatch, getState }) => {
  try {
    let response;
    const { selectedItems, folderHistory } = getState().Folder;
    let i = 0;
    do {
      response = await dispatch(moveItemToFolder({ item: selectedItems[i], folder: folderHistory[folderHistory.length - 1] }));
      i++;
    } while (i < selectedItems.length);
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});